import { render, staticRenderFns } from "./DeletionRequests.vue?vue&type=template&id=3e39e5d7"
import script from "./DeletionRequests.vue?vue&type=script&lang=js"
export * from "./DeletionRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports